<template>
    <div>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">PIN Transaksi</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule">
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <p class="text-center mb-3">PIN Transaksi bersifat rahasia, jangan berikan PIN kamu ke pihak manapun termasuk pihak {{VUE_ENV.VUE_APP_NAME}}, segala tindakan kelalaian yang dilakukan pengguna adalah diluar tanggung jawab kami.</p>
                    <ul class="listview simple-listview transparent flush">
                        <li>
                            <div>PIN Transaksi</div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="pinTrx" v-model="data.pin_trx" @change="changeTogglePin">
                                <label class="custom-control-label" for="pinTrx"></label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section inset mt-1">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group basic" v-if="this.data.pin_trx == true">
                        <label class="label">Atur PIN</label>
                        <input type="number" pattern="[0-9]*" inputmode="numeric" class="form-control input-password" style="letter-spacing: 0.7em;" maxlength="6" v-model="data.pin" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
                    </div>
                    <div class="form-group basic" v-if="this.data.pin_trx == true">
                        <label class="label">Ulangi PIN</label>
                        <input type="number" pattern="[0-9]*" inputmode="numeric" class="form-control input-password" style="letter-spacing: 0.7em" maxlength="6" v-model="data.confirm_pin" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
                    </div>
                    <div class="form-group basic">
                        <label class="label mb-1">Kode OTP</label>
                        <div class="input-group">
                            <input type="number" class="form-control" v-model="data.confirm_code" placeholder="Ketik disini">
                            <div class="input-group-append">
                                <span class="input-group-text text-primary">
                                    <a href="Javascript:;" @click="showSender()"><small >Minta OTP</small></a>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button class="btn btn-primary btn-block btn-lg" @click="showDialog('show')">Simpan Perubahan</button>
                    </div>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="accordion" id="faq">
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#FAQ0'">
                                <b>Kenapa mengatur PIN Transaksi diperlukan?</b>
                            </button>
                        </div>
                        <div :id="'FAQ0'" class="accordion-body collapse" data-parent="#faq">
                            <div class="accordion-content">
                                <p>Mengatur PIN Transaksi merupakan salah satu tindakan untuk bisa mengamankan akun kamu dari tindakan kejahatan penyalahgunaan akun atau tindakan kejahatan lainnya.</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#FAQ1'">
                                <b>Bagaiaman Tips Aman bertransaksi diaplikasi {{VUE_ENV.VUE_APP_NAME}}?</b>
                            </button>
                        </div>
                        <div :id="'FAQ1'" class="accordion-body collapse" data-parent="#faq">
                            <div class="accordion-content">
                                <p>
                                    <ol>
                                        <li>Mengatur PIN Transkasi</li>
                                        <li>Tindak memberikan data PIN, OTP, Dll yang sifatnya rahasia ke pihak manapun termasuk pihak {{VUE_ENV.VUE_APP_NAME}}.</li>
                                        <li>Lakukan pergantian PIN Transaksi secara berkala.</li>
                                        <li>Tidak mudah percaya pada tawaran apapun dari orang yang tidak andak kenal atau meragukan.</li>
                                    </ol>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog ref="dialog" :loading="dialogLoading" :title="'Simpan'" @confirm="submit()">
            <p>Kamu yakin akan merubah PIN Transaksi?</p>
        </Dialog>

        <action-sheet-sender ref="sender" :phone="customer.phone" :inset="true"></action-sheet-sender>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.data-outlet',
    data() {
        return {
            loading: false,
            dialogLoading: false,
            data: {
                pin_trx: false,
                pin: '',
                confirm_pin: '',
                confirm_code: '',
            }
        }
    },
    created() {
        this.loading = true
        this.getCustomer().then(() => {
            this.data.pin_trx = this.customer.pin_trx == 'ENABLED' ? true:false
            this.loading = false
        })
    },
    computed: {
        ...mapState(['customer','toast','VUE_ENV'])
    },
    methods: {
        ...mapActions(['getCustomer']),
        showSender(){
            let element = this.$refs.sender.$el
            window.$(element).modal('show')
        },
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        changeTogglePin(){
            if(this.data.pin_trx == false){
                this.data = {
                    pin_trx: this.data.pin_trx,
                    pin: '',
                    confirm_pin: '',
                    confirm_code: '',
                }
            }
        },
        submit(){
            this.dialogLoading = true
            $axios.post('/pin',this.data)
            .then((response) => {
                this.showDialog('hide')
                this.dialogLoading = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.data = {
                    pin_trx: this.customer.pin_trx == 'ENABLED' ? true:false,
                    pin: '',
                    confirm_pin: '',
                    confirm_code: ''
                }
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'default',icon:'success'})
            }).catch((error) => {
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.showDialog('hide')
                this.dialogLoading = false
            })
        }
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
}
</script>